import { render } from "./VerifyOtpLogin.vue?vue&type=template&id=5c6f78fb&scoped=true"
import script from "./VerifyOtpLogin.vue?vue&type=script&lang=js"
export * from "./VerifyOtpLogin.vue?vue&type=script&lang=js"

import "./VerifyOtpLogin.vue?vue&type=style&index=0&id=5c6f78fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6f78fb"]])

export default __exports__